export function formatCurrency(value) {
  return `\u20b9${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
}

export function formatNumber(value) {
  return Number(value || 0).toLocaleString("en-IN");
}

export function formatTitleCase(value) {
  return String(value || "").toLowerCase().replace(/[A-Za-z]+/g, (word) =>
    word.charAt(0).toUpperCase() + word.slice(1)
  );
}

export function formatDecimal(value) {
  return Number(value || 0).toFixed(1);
}

export function formatAxisCompactCurrency(value) {
  return `\u20b9${Number(value / 1000).toFixed(0)}k`;
}

export function formatCompactCurrency(value) {
  const amount = Number(value || 0);

  if (amount >= 10000000) {
    return `\u20b9${(amount / 10000000).toFixed(2)}Cr`;
  }
  if (amount >= 100000) {
    return `\u20b9${(amount / 100000).toFixed(2)}L`;
  }
  if (amount >= 1000) {
    return `\u20b9${(amount / 1000).toFixed(1)}k`;
  }

  return `\u20b9${amount.toFixed(0)}`;
}

export function formatAxisCompactNumber(value) {
  return `${Number(value / 1000).toFixed(0)}k`;
}

export function formatCompactNumber(value) {
  const amount = Number(value || 0);

  if (amount >= 10000000) {
    return `${(amount / 10000000).toFixed(2)}Cr`;
  }
  if (amount >= 100000) {
    return `${(amount / 100000).toFixed(2)}L`;
  }
  if (amount >= 1000) {
    return `${(amount / 1000).toFixed(1)}k`;
  }

  return `${amount.toFixed(0)}`;
}

export function formatMonthYearLabel(value) {
  const raw = String(value || "").trim();

  if (!raw) {
    return "";
  }

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const ymMatch = raw.match(/^(\d{4})-(\d{1,2})(?:-\d{1,2})?$/);
  if (ymMatch) {
    const year = Number(ymMatch[1]);
    const monthIndex = Number(ymMatch[2]) - 1;

    if (year >= 1900 && monthIndex >= 0 && monthIndex < 12) {
      return `${monthNames[monthIndex]}-${year}`;
    }
  }

  const monthOnly = Number(raw);
  if (Number.isInteger(monthOnly) && monthOnly >= 1 && monthOnly <= 12) {
    return monthNames[monthOnly - 1];
  }

  return raw;
}

export function buildMonthYearLabel(value, fallbackYear) {
  const base = formatMonthYearLabel(value);
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  if (!base) {
    return "";
  }

  if (/^[A-Za-z]{3}-\d{4}$/.test(base)) {
    return base;
  }

  const monthIndex = monthNames.indexOf(base);
  if (monthIndex === -1) {
    return base;
  }

  const validFallbackYear = Number.isInteger(fallbackYear) && fallbackYear >= 1900
    ? fallbackYear
    : null;

  return validFallbackYear ? `${monthNames[monthIndex]}-${validFallbackYear}` : base;
}
